import type { FC, HTMLProps } from "react";

import * as styles from "./Price.styles";

interface Props extends HTMLProps<HTMLSpanElement> {
  price: number;
  displayColor?: "dark" | "grey" | "blue" | "text";
  isNegative?: boolean;
  currencySymbol?: "CAN" | "US";
}

const Price: FC<Props> = ({ price, displayColor, isNegative, currencySymbol, ...rest }) => {
  const minusSign = isNegative ? "-" : "";

  return (
    <span css={displayColor && styles.price[displayColor]} {...rest}>{`${minusSign}${
      currencySymbol ? currencySymbol : ""
    }$${Number(price).toFixed(2)}`}</span>
  );
};

export { Price };
